import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { FormikProvider } from 'formik';

import Icon from 'app/components/Icon';
import { Colors } from 'app/utils/colors';
import { formatDateToLocale } from 'app/utils/dates';
import Divider from 'app/components/Divider';
import Checkbox from 'app/components/Checkbox';
import Spinner from 'app/components/Spinner';

import styles from './styles.module.scss';

export default function ExtraInfo({ formik, showForm, isLoading }) {
  const intl = useIntl();
  const {
    user: {
      attributes: { packExpirationDate, subscriptionRenewCancelDate }
    }
  } = useSelector((state) => state.auth);

  return (
    <>
      {packExpirationDate && (
        <Row>
          <Col xs={6} md={3} className={styles.centerContent}>
            <Icon icon="calendar-alt" size="lg" color={Colors.bbGrey2} />
            <p>
              {intl.formatMessage({
                id: 'controlpanel.wholesaler_pack.column.active_until'
              })}
            </p>
          </Col>
          <Col xs={6} md={9}>
            <b>{formatDateToLocale(packExpirationDate)}</b>
          </Col>
        </Row>
      )}
      {subscriptionRenewCancelDate && (
        <>
          <Row>
            <Col>
              <Divider type="dash" />
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={3} className={styles.centerContent}>
              <Icon icon="calendar-xmark" size="lg" color={Colors.bbGrey2} />
              <p>
                {intl.formatMessage({
                  id: 'controlpanel.wholesaler_pack.column.cancelation_date'
                })}
              </p>
            </Col>
            <Col xs={6} md={9}>
              <b>{formatDateToLocale(subscriptionRenewCancelDate)}</b>
            </Col>
          </Row>
        </>
      )}
      {showForm && (
        <Row>
          <Col xs={6} md={3} className={styles.centerContent}>
            <Icon icon="credit-card" size="lg" color={Colors.bbGrey2} />
            <p>
              {intl.formatMessage({
                id: 'controlpanel.wholesaler_pack.column.payment_backup'
              })}
            </p>
          </Col>
          <Col xs={6} md={9}>
            <FormikProvider value={formik}>
              {isLoading ? (
                <Spinner />
              ) : (
                <div className={styles.checkboxContainer}>
                  <Checkbox
                    id="isActivatePaymentByWallet"
                    name="isActivatePaymentByWallet"
                    type="checkbox"
                    label={
                      <b>
                        {intl.formatMessage({
                          id: 'controlpanel.wholesaler_pack.checkbox.label'
                        })}
                      </b>
                    }
                  />
                  <p>
                    {intl.formatMessage({
                      id: 'controlpanel.wholesaler_pack.checkbox.text'
                    })}
                  </p>
                </div>
              )}
            </FormikProvider>
          </Col>
        </Row>
      )}
    </>
  );
}

ExtraInfo.propTypes = {
  formik: PropTypes.shape({}).isRequired,
  showForm: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};
